<template>
	<div class="meaning">
		<span class="label">{{label}}</span>
		<span class="value">{{value}}</span>
		
	</div>
</template>

<script>
export default {
	props: ['label','value','synonyms'],
}
</script>
<style scoped lang="scss">
	.meaning {
		display: inline-block;
		background: $mondadori-light-blue;
		padding: px(20);
		color: $mondadori-blue;
		border: $border-size solid #fff;
		border-radius: px(20);
		line-height: 1.2;
		width: 100%;
		
		@include breakpoint(s) {
			padding: px(7);
		}

		span {
			display: block;
			width: 100%;
		}
		.synonyms {
			display: flex;
			span {
				display: inline-block;
				width: auto;
			}
		}
		.label {
			text-transform: uppercase;
			@include breakpoint(s) {
				font-size: px(14);
				margin-bottom: 0.3rem;
			}
		}
		.value {
			display: block;
			width: 100%;
			font-size: px(28);
			@include breakpoint(s) {
				font-size: 1.1rem;
			}
		}
	}
</style>